// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';
//import appConfig from "../../config/appConfig";

// HOOKS
import { useGetAgentsByAgency } from "../../hooks/useGetAgents";
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import AgentsSection from "./AgentsSection";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
//import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
//import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";

interface AboutUsProps {
    agencyId: number;
    showAgents: boolean;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId, showAgents }) => {
    const { t } = useTranslation();
    //const partners = appConfig.content.partners;
    const { agents, loading: agentsLoading, error: agentsError } = useGetAgentsByAgency(agencyId);
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;
    if (agentsLoading && showAgents) return <LoadingIndicator />;
    if (agentsError && showAgents) console.error("Error fetching agents:", agentsError);

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Lato:wght@300;400&display=swap" rel="stylesheet" />
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.subHeaderTitle')} isSeo={true} />

            <main id="about-us-page" className="space-ptb bg-custom position-relative">
                <div className="container-fluid">
                    <div className="row align-items-center justify-content-around mb-4">
                        <div className="col-12 col-lg-8">
                            <h2 className="mb-4">{t('aboutUsPage.services.title')}</h2>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.services.para1') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.services.para2') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.services.para3') as string }} />
                        </div>
                        <div className="col-12 col-lg-4">
                            <img src="/assets/images/altrePag/chiave.webp" alt={t('aboutUsPage.services.imageAlt') as string} className="img-fluid img-border" />
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-around mb-4">
                        <div className="col-12 col-lg-8 order-lg-2">
                            <h2 className="mb-4">{t('aboutUsPage.experience.title')}</h2>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.experience.para1') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.experience.para2') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.experience.para3') as string }} />
                        </div>
                        <div className="col-12 col-lg-4 order-lg-1">
                            <img src="/assets/images/altrePag/vaselli.webp" alt="Vaselli" className="img-fluid img-border" />
                        </div>
                    </div>
                    <AgentsSection
                        showAgents={showAgents}
                        agents={agents}
                        agentsLoading={agentsLoading}
                        agentsError={agentsError}
                    />
                </div>
            </main>
        </>
    );
};
export default AboutUs;